import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenter, FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';

interface Props {
  title: string;
  children: any;
}

function BlockWithTitle({ title, children }: Props) {
  return (
    <Wrapper>
      <Text>{title}</Text>
      {children}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  margin-bottom: ${rem(56)};
  width: 100%;
  border: ${({ theme }) => theme.borders.primary};
  position: relative;

  &:last-child {
    margin-bottom: ${rem(32)};
  }

  ${({ theme }) => theme.mediab.m580`
    margin-bottom: ${rem(32)};
  `}
`;

const Text = styled(TextP)`
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(22)};
  position: absolute;
  top: -${rem(12)};
  left: ${rem(24)};
  background: ${({ theme }) => theme.colors.white};
  padding: 0 ${rem(8)};

  ${({ theme }) => theme.mediab.s450`
    left: ${rem(8)};
  `}
`;

export { BlockWithTitle };
